<template>
<div id="content">
  
  <div id="about">
    <div id="cont">
<table align="left" border="0" cellpadding="0" cellspacing="0" style="margin: 0px auto; padding: 0px; list-style: none;" width="200">
        <tbody style="margin: 0px auto; padding: 0px; list-style: none;">
            <tr style="margin: 0px auto; padding: 0px; list-style: none;">
                <td style="margin: 0px auto; padding: 0px; list-style: none;">
                    &nbsp;</td>
                <td style="margin: 0px auto; padding: 0px; list-style: none;">
                    &nbsp;</td>
            </tr>
            <tr style="margin: 0px auto; padding: 0px; list-style: none;">
                <td class="b5" height="35" style="margin: 0px auto; padding: 0px; list-style: none; border-bottom-width: 1px; border-bottom-style: solid; border-bottom-color: rgb(226, 226, 226);" width="20">
                    <img height="12" src="./images/newslist.gif" style="margin: 0px auto; padding: 0px; list-style: none;" width="12"></td>
                <td class="b5" style="margin: 0px auto; padding: 0px; list-style: none; border-bottom-width: 1px; border-bottom-style: solid; border-bottom-color: rgb(226, 226, 226);">
                    <a class="f7" @click="jumppage('1')" style="margin: 0px auto; padding: 0px; list-style: none; text-decoration: none; font-size: 16px; color: rgb(136, 136, 136);">
                    企业简介</a></td>
            </tr>
            <tr style="margin: 0px auto; padding: 0px; list-style: none;">
                <td class="b5" height="35" style="margin: 0px auto; padding: 0px; list-style: none; border-bottom-width: 1px; border-bottom-style: solid; border-bottom-color: rgb(226, 226, 226);">
                    <img height="12" src="./images/newslist.gif" style="margin: 0px auto; padding: 0px; list-style: none;" width="12"></td>
                <td class="b5" style="margin: 0px auto; padding: 0px; list-style: none; border-bottom-width: 1px; border-bottom-style: solid; border-bottom-color: rgb(226, 226, 226);">
                    <a class="f7" @click="jumppage('3')" style="margin: 0px auto; padding: 0px; list-style: none; text-decoration: none; font-size: 16px; color: rgb(136, 136, 136);">
                    企业荣誉</a></td>
            </tr>
            <tr style="margin: 0px auto; padding: 0px; list-style: none;">
                <td class="b5" height="35" style="margin: 0px auto; padding: 0px; list-style: none; border-bottom-width: 1px; border-bottom-style: solid; border-bottom-color: rgb(226, 226, 226);">
                    <img height="12" src="./images/newslist.gif" style="margin: 0px auto; padding: 0px; list-style: none;" width="12"></td>
                <td class="b5" style="margin: 0px auto; padding: 0px; list-style: none; border-bottom-width: 1px; border-bottom-style: solid; border-bottom-color: rgb(226, 226, 226);">
                    <a class="f7" @click="jumppage('4')" style="margin: 0px auto; padding: 0px; list-style: none; text-decoration: none; font-size: 14px; color: rgb(136, 136, 136);">
                    样品展示</a></td>
            </tr>
        </tbody>
    </table>
            <div  id="info" v-if="$i18n.locale=='en'" v-html="info.remark_en"></div>
            <div  id="info" v-else v-html="info.remark"></div>
  </div>
  </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: 'About',
  data() {
    return {
      info: {},
      id:1
    };
  },
  mounted() {
    if(this.$route.params.id)
    this.id = this.$route.params.id
    // alert(this.$route.params.id);
    // 使用
    const params = { id: this.id  }; // 参数
    fetch.post("/api/ApiSystemInfo/Get", params).then(
      (res) => {
        this.info = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  },
  methods:{
    jumppage(p)
    {
    const params = { id: p  }; // 参数
    fetch.post("/api/ApiSystemInfo/Get", params).then(
      (res) => {
        this.info = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    }
  }
};
</script>

<style>
#about {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#cont {
  width:1400px; margin:20px auto auto;
}

#info {
  width:880px; margin-left:210px ;
}



</style>



// WEBPACK FOOTER //
// src/About.vue